var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInterneBenefits({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-InterneBenefits",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71376",
    "data-name": "Group 71376",
    transform: "translate(-19029.834 -4202.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39717",
    "data-name": "Path 39717",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    transform: "translate(19029.834 4202.646)",
    stroke: "none",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39720",
    "data-name": "Path 39720",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(19040.916 4213.728)",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "temp_preferences_custom_FILL1_wght600_GRAD0_opsz48",
    d: "M4.635,7.756l.971-2.232L7.941,4.491,5.607,3.478,4.635,1.35,3.664,3.478,1.35,4.491,3.664,5.524Zm0,12.295L5.607,17.9l2.335-1.012L5.607,15.876l-.971-2.252-.971,2.252L1.35,16.889,3.664,17.9Zm9.03-3.1,2-4.3L20.05,10.69,15.669,8.727l-2-4.277L11.64,8.727,7.3,10.69l4.339,1.963Z",
    transform: "translate(19053.832 4209.258)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "volunteer_activism_FILL1_wght600_GRAD0_opsz48",
    d: "M18.8,38.006l-9.957-2.84V23.25h2.938l8.39,3.167a3.812,3.812,0,0,1,1.7,1.192,3.63,3.63,0,0,1,.686,2.367H20.037a19.676,19.676,0,0,1-2.334-.1,9.61,9.61,0,0,1-1.649-.392l-2.285-.751-.457,1.306,2.546.881a8.43,8.43,0,0,0,1.681.343,16.768,16.768,0,0,0,1.91.114h6.4a4.842,4.842,0,0,1,2.873.6,2.226,2.226,0,0,1,.751,1.845v.947ZM1.2,36.961V23.25H6.423V36.961Z",
    transform: "translate(19038.184 4205.506)",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInterneBenefits);
export default __webpack_public_path__ + "static/media/ic-InterneBenefits.7951d2e286abad606b5e0fe15aafae0e.svg";
export { ForwardRef as ReactComponent };